import { Nationality } from "../models/nationalityDto";
import { Occupation } from "../models/occupation";
import { Establishment } from "../models/establishment";
import { Sex } from "../models/sexDto";

export const nationalities: Nationality[] = [
  {
    fr_label: "Afghanistan",
    en_label: "Afghanistan",
    value: "Afghanistan",
  },
  {
    fr_label: "Afrique du Sud",
    en_label: "South Africa",
    value: "South Africa",
  },
  {
    fr_label: "Albanie",
    en_label: "Albania",
    value: "Albania",
  },
  {
    fr_label: "Algérie",
    en_label: "Algeria",
    value: "Algeria",
  },
  {
    fr_label: "Allemagne",
    en_label: "Germany",
    value: "Germany",
  },
  {
    fr_label: "Andorre",
    en_label: "Andorra",
    value: "Andorra",
  },
  {
    fr_label: "Angola",
    en_label: "Angola",
    value: "Angola",
  },
  {
    fr_label: "Antigua-et-Barbuda",
    en_label: "Antigua and Barbuda",
    value: "Antigua and Barbuda",
  },
  {
    fr_label: "Arabie saoudite",
    en_label: "Saudi Arabia",
    value: "Saudi Arabia",
  },
  {
    fr_label: "Argentine",
    en_label: "Argentina",
    value: "Argentina",
  },
  {
    fr_label: "Arménie",
    en_label: "Armenia",
    value: "Armenia",
  },
  {
    fr_label: "Australie",
    en_label: "Australia",
    value: "Australia",
  },
  {
    fr_label: "Autriche",
    en_label: "Austria",
    value: "Austria",
  },
  {
    fr_label: "Azerbaïdjan",
    en_label: "Azerbaijan",
    value: "Azerbaijan",
  },
  {
    fr_label: "Bahamas",
    en_label: "Bahamas",
    value: "Bahamas",
  },
  {
    fr_label: "Bahreïn",
    en_label: "Bahrain",
    value: "Bahrain",
  },
  {
    fr_label: "Bangladesh",
    en_label: "Bangladesh",
    value: "Bangladesh",
  },
  {
    fr_label: "Barbade",
    en_label: "Barbados",
    value: "Barbados",
  },
  {
    fr_label: "Biélorussie",
    en_label: "Belarus",
    value: "Belarus",
  },
  {
    fr_label: "Belgique",
    en_label: "Belgium",
    value: "Belgium",
  },
  {
    fr_label: "Belize",
    en_label: "Belize",
    value: "Belize",
  },
  {
    fr_label: "Bénin",
    en_label: "Benin",
    value: "Benin",
  },
  {
    fr_label: "Bhoutan",
    en_label: "Bhutan",
    value: "Bhutan",
  },
  {
    fr_label: "Bolivie",
    en_label: "Bolivia",
    value: "Bolivia",
  },
  {
    fr_label: "Bosnie-Herzégovine",
    en_label: "Bosnia and Herzegovina",
    value: "Bosnia and Herzegovina",
  },
  {
    fr_label: "Botswana",
    en_label: "Botswana",
    value: "Botswana",
  },
  {
    fr_label: "Brésil",
    en_label: "Brazil",
    value: "Brazil",
  },
  {
    fr_label: "Brunei",
    en_label: "Brunei",
    value: "Brunei",
  },
  {
    fr_label: "Bulgarie",
    en_label: "Bulgaria",
    value: "Bulgaria",
  },
  {
    fr_label: "Burkina Faso",
    en_label: "Burkina Faso",
    value: "Burkina Faso",
  },
  {
    fr_label: "Burundi",
    en_label: "Burundi",
    value: "Burundi",
  },
  {
    fr_label: "Cambodge",
    en_label: "Cambodia",
    value: "Cambodia",
  },
  {
    fr_label: "Cameroun",
    en_label: "Cameroon",
    value: "Cameroon",
  },
  {
    fr_label: "Canada",
    en_label: "Canada",
    value: "Canada",
  },
  {
    fr_label: "Cap-Vert",
    en_label: "Cape Verde",
    value: "Cape Verde",
  },
  {
    fr_label: "République centrafricaine",
    en_label: "Central African Republic",
    value: "Central African Republic",
  },
  {
    fr_label: "Chili",
    en_label: "Chile",
    value: "Chile",
  },
  {
    fr_label: "Chine",
    en_label: "China",
    value: "China",
  },
  {
    fr_label: "Chypre (pays)",
    en_label: "Cyprus (country)",
    value: "Cyprus (country)",
  },
  {
    fr_label: "Colombie",
    en_label: "Colombia",
    value: "Colombia",
  },
  {
    fr_label: "Comores (pays)",
    en_label: "Comoros (country)",
    value: "Comoros (country)",
  },
  {
    fr_label: "République du Congo",
    en_label: "Republic of Congo",
    value: "Republic of Congo",
  },
  {
    fr_label: "République démocratique du Congo",
    en_label: "Democratic Republic of Congo",
    value: "Democratic Republic of Congo",
  },
  {
    fr_label: "Corée du Sud",
    en_label: "South Korea",
    value: "South Korea",
  },
  {
    fr_label: "Corée du Nord",
    en_label: "North Korea",
    value: "North Korea",
  },
  {
    fr_label: "Costa Rica",
    en_label: "Costa Rica",
    value: "Costa Rica",
  },
  {
    fr_label: "Côte d'Ivoire",
    en_label: "Ivory Coast",
    value: "Ivory Coast",
  },
  {
    fr_label: "Croatie",
    en_label: "Croatia",
    value: "Croatia",
  },
  {
    fr_label: "Cuba",
    en_label: "Cuba",
    value: "Cuba",
  },
  {
    fr_label: "Danemark",
    en_label: "Denmark",
    value: "Denmark",
  },
  {
    fr_label: "Djibouti",
    en_label: "Djibouti",
    value: "Djibouti",
  },
  {
    fr_label: "République dominicaine",
    en_label: "Dominican Republic",
    value: "Dominican Republic",
  },
  {
    fr_label: "Dominique",
    en_label: "Dominique",
    value: "Dominique",
  },
  {
    fr_label: "Égypte",
    en_label: "Egypt",
    value: "Egypt",
  },
  {
    fr_label: "Salvador",
    en_label: "Salvador",
    value: "Salvador",
  },
  {
    fr_label: "Émirats arabes unis",
    en_label: "United Arab Emirates",
    value: "United Arab Emirates",
  },
  {
    fr_label: "Équateur (pays)",
    en_label: "Ecuador (country)",
    value: "Ecuador (country)",
  },
  {
    fr_label: "Érythrée",
    en_label: "Eritrea",
    value: "Eritrea",
  },
  {
    fr_label: "Espagne",
    en_label: "Spain",
    value: "Spain",
  },
  {
    fr_label: "Estonie",
    en_label: "Estonia",
    value: "Estonia",
  },
  {
    fr_label: "États-Unis",
    en_label: "United States",
    value: "United States",
  },
  {
    fr_label: "Éthiopie",
    en_label: "Ethiopia",
    value: "Ethiopia",
  },
  {
    fr_label: "Fidji",
    en_label: "Fiji",
    value: "Fiji",
  },
  {
    fr_label: "Finlande",
    en_label: "Finland",
    value: "Finland",
  },
  {
    fr_label: "France",
    en_label: "France",
    value: "France",
  },
  {
    fr_label: "Gabon",
    en_label: "Gabon",
    value: "Gabon",
  },
  {
    fr_label: "Gambie",
    en_label: "Gambia",
    value: "Gambia",
  },
  {
    fr_label: "Géorgie (pays)",
    en_label: "Georgia (country)",
    value: "Georgia (country)",
  },
  {
    fr_label: "Ghana",
    en_label: "Ghana",
    value: "Ghana",
  },
  {
    fr_label: "Grèce",
    en_label: "Greece",
    value: "Greece",
  },
  {
    fr_label: "Grenade (pays)",
    en_label: "Grenada (country)",
    value: "Grenada (country)",
  },
  {
    fr_label: "Guatemala",
    en_label: "Guatemala",
    value: "Guatemala",
  },
  {
    fr_label: "Guinée",
    en_label: "Guinea",
    value: "Guinea",
  },
  {
    fr_label: "Guinée-Bissau",
    en_label: "Guinea-Bissau",
    value: "Guinea-Bissau",
  },
  {
    fr_label: "Guinée équatoriale",
    en_label: "Equatorial Guinea",
    value: "Equatorial Guinea",
  },
  {
    fr_label: "Guyana",
    en_label: "Guyana",
    value: "Guyana",
  },
  {
    fr_label: "Haïti",
    en_label: "Haiti",
    value: "Haiti",
  },
  {
    fr_label: "Honduras",
    en_label: "Honduras",
    value: "Honduras",
  },
  {
    fr_label: "Hongrie",
    en_label: "Hungary",
    value: "Hungary",
  },
  {
    fr_label: "Inde",
    en_label: "India",
    value: "India",
  },
  {
    fr_label: "Indonésie",
    en_label: "Indonesia",
    value: "Indonesia",
  },
  {
    fr_label: "Iran",
    en_label: "Iran",
    value: "Iran",
  },
  {
    fr_label: "Irak",
    en_label: "Iraq",
    value: "Iraq",
  },
  {
    fr_label: "Irlande (pays)",
    en_label: "Ireland (country)",
    value: "Ireland (country)",
  },
  {
    fr_label: "Islande",
    en_label: "Iceland",
    value: "Iceland",
  },
  {
    fr_label: "Israël",
    en_label: "Israel",
    value: "Israel",
  },
  {
    fr_label: "Italie",
    en_label: "Italy",
    value: "Italy",
  },
  {
    fr_label: "Jamaïque",
    en_label: "Jamaica",
    value: "Jamaica",
  },
  {
    fr_label: "Japon",
    en_label: "Japan",
    value: "Japan",
  },
  {
    fr_label: "Jordanie",
    en_label: "Jordan",
    value: "Jordan",
  },
  {
    fr_label: "Kazakhstan",
    en_label: "Kazakhstan",
    value: "Kazakhstan",
  },
  {
    fr_label: "Kenya",
    en_label: "Kenya",
    value: "Kenya",
  },
  {
    fr_label: "Kirghizistan",
    en_label: "Kyrgyzstan",
    value: "Kyrgyzstan",
  },
  {
    fr_label: "Kiribati",
    en_label: "Kiribati",
    value: "Kiribati",
  },
  {
    fr_label: "Koweït",
    en_label: "Kuwait",
    value: "Kuwait",
  },
  {
    fr_label: "Laos",
    en_label: "Laos",
    value: "Laos",
  },
  {
    fr_label: "Lesotho",
    en_label: "Lesotho",
    value: "Lesotho",
  },
  {
    fr_label: "Lettonie",
    en_label: "Latvia",
    value: "Latvia",
  },
  {
    fr_label: "Liban",
    en_label: "Lebanon",
    value: "Lebanon",
  },
  {
    fr_label: "Liberia",
    en_label: "Liberia",
    value: "Liberia",
  },
  {
    fr_label: "Libye",
    en_label: "Libya",
    value: "Libya",
  },
  {
    fr_label: "Liechtenstein",
    en_label: "Liechtenstein",
    value: "Liechtenstein",
  },
  {
    fr_label: "Lituanie",
    en_label: "Lithuania",
    value: "Lithuania",
  },
  {
    fr_label: "Luxembourg (pays)",
    en_label: "Luxembourg (country)",
    value: "Luxembourg (country)",
  },
  {
    fr_label: "Macédoine du Nord",
    en_label: "North Macedonia",
    value: "North Macedonia",
  },
  {
    fr_label: "Madagascar",
    en_label: "Madagascar",
    value: "Madagascar",
  },
  {
    fr_label: "Malaisie",
    en_label: "Malaysia",
    value: "Malaysia",
  },
  {
    fr_label: "Malawi",
    en_label: "Malawi",
    value: "Malawi",
  },
  {
    fr_label: "Maldives",
    en_label: "Maldives",
    value: "Maldives",
  },
  {
    fr_label: "Mali",
    en_label: "Mali",
    value: "Mali",
  },
  {
    fr_label: "Malte",
    en_label: "Malta",
    value: "Malta",
  },
  {
    fr_label: "Maroc",
    en_label: "Morocco",
    value: "Morocco",
  },
  {
    fr_label: "Îles Marshall (pays)",
    en_label: "Marshall Islands (country)",
    value: "Marshall Islands (country)",
  },
  {
    fr_label: "Maurice (pays)",
    en_label: "Mauritius (country)",
    value: "Mauritius (country)",
  },
  {
    fr_label: "Mauritanie",
    en_label: "Mauritania",
    value: "Mauritania",
  },
  {
    fr_label: "Mexique",
    en_label: "Mexico",
    value: "Mexico",
  },
  {
    fr_label: "États fédérés de Micronésie (pays)",
    en_label: "Federated States of Micronesia (country)",
    value: "Federated States of Micronesia (country)",
  },
  {
    fr_label: "Moldavie",
    en_label: "Moldova",
    value: "Moldova",
  },
  {
    fr_label: "Monaco",
    en_label: "Monaco",
    value: "Monaco",
  },
  {
    fr_label: "Mongolie",
    en_label: "Mongolia",
    value: "Mongolia",
  },
  {
    fr_label: "Monténégro",
    en_label: "Montenegro",
    value: "Montenegro",
  },
  {
    fr_label: "Mozambique",
    en_label: "Mozambique",
    value: "Mozambique",
  },
  {
    fr_label: "Birmanie",
    en_label: "Burma",
    value: "Burma",
  },
  {
    fr_label: "Namibie",
    en_label: "Namibia",
    value: "Namibia",
  },
  {
    fr_label: "Nauru",
    en_label: "Nauru",
    value: "Nauru",
  },
  {
    fr_label: "Népal",
    en_label: "Nepal",
    value: "Nepal",
  },
  {
    fr_label: "Nicaragua",
    en_label: "Nicaragua",
    value: "Nicaragua",
  },
  {
    fr_label: "Niger",
    en_label: "Niger",
    value: "Niger",
  },
  {
    fr_label: "Nigeria",
    en_label: "Nigeria",
    value: "Nigeria",
  },
  {
    fr_label: "Norvège",
    en_label: "Norway",
    value: "Norway",
  },
  {
    fr_label: "Nouvelle-Zélande",
    en_label: "New Zealand",
    value: "New Zealand",
  },
  {
    fr_label: "Oman",
    en_label: "Oman",
    value: "Oman",
  },
  {
    fr_label: "Ouganda",
    en_label: "Uganda",
    value: "Uganda",
  },
  {
    fr_label: "Ouzbékistan",
    en_label: "Uzbekistan",
    value: "Uzbekistan",
  },
  {
    fr_label: "Pakistan",
    en_label: "Pakistan",
    value: "Pakistan",
  },
  {
    fr_label: "Palaos",
    en_label: "Palau",
    value: "Palau",
  },
  {
    fr_label: "Panama",
    en_label: "Panama",
    value: "Panama",
  },
  {
    fr_label: "Papouasie-Nouvelle-Guinée",
    en_label: "Papua New Guinea",
    value: "Papua New Guinea",
  },
  {
    fr_label: "Paraguay",
    en_label: "Paraguay",
    value: "Paraguay",
  },
  {
    fr_label: "Pays-Bas",
    en_label: "Netherlands",
    value: "Netherlands",
  },
  {
    fr_label: "Pérou",
    en_label: "Peru",
    value: "Peru",
  },
  {
    fr_label: "Philippines",
    en_label: "Philippines",
    value: "Philippines",
  },
  {
    fr_label: "Pologne",
    en_label: "Poland",
    value: "Poland",
  },
  {
    fr_label: "Portugal",
    en_label: "Portugal",
    value: "Portugal",
  },
  {
    fr_label: "Qatar",
    en_label: "Qatar",
    value: "Qatar",
  },
  {
    fr_label: "Roumanie",
    en_label: "Romania",
    value: "Romania",
  },
  {
    fr_label: "Royaume-Uni",
    en_label: "United Kingdom",
    value: "United Kingdom",
  },
  {
    fr_label: "Russie",
    en_label: "Russia",
    value: "Russia",
  },
  {
    fr_label: "Rwanda",
    en_label: "Rwanda",
    value: "Rwanda",
  },
  {
    fr_label: "Saint-Christophe-et-Niévès",
    en_label: "Saint Kitts and Nevis",
    value: "Saint Kitts and Nevis",
  },
  {
    fr_label: "Saint-Marin",
    en_label: "San Marino",
    value: "San Marino",
  },
  {
    fr_label: "Saint-Vincent-et-les-Grenadines",
    en_label: "Saint Vincent and the Grenadines",
    value: "Saint Vincent and the Grenadines",
  },
  {
    fr_label: "Sainte-Lucie",
    en_label: "Saint Lucia",
    value: "Saint Lucia",
  },
  {
    fr_label: "Îles Salomon",
    en_label: "Solomon Islands",
    value: "Solomon Islands",
  },
  {
    fr_label: "Samoa",
    en_label: "Samoa",
    value: "Samoa",
  },
  {
    fr_label: "Sao Tomé-et-Principe",
    en_label: "Sao Tome and Principe",
    value: "Sao Tome and Principe",
  },
  {
    fr_label: "Sénégal",
    en_label: "Senegal",
    value: "Senegal",
  },
  {
    fr_label: "Serbie",
    en_label: "Serbia",
    value: "Serbia",
  },
  {
    fr_label: "Seychelles",
    en_label: "Seychelles",
    value: "Seychelles",
  },
  {
    fr_label: "Sierra Leone",
    en_label: "Sierra Leone",
    value: "Sierra Leone",
  },
  {
    fr_label: "Singapour",
    en_label: "Singapore",
    value: "Singapore",
  },
  {
    fr_label: "Slovaquie",
    en_label: "Slovakia",
    value: "Slovakia",
  },
  {
    fr_label: "Slovénie",
    en_label: "Slovenia",
    value: "Slovenia",
  },
  {
    fr_label: "Somalie",
    en_label: "Somalia",
    value: "Somalia",
  },
  {
    fr_label: "Soudan",
    en_label: "Sudan",
    value: "Sudan",
  },
  {
    fr_label: "Soudan du Sud",
    en_label: "South Sudan",
    value: "South Sudan",
  },
  {
    fr_label: "Sri Lanka",
    en_label: "Sri Lanka",
    value: "Sri Lanka",
  },
  {
    fr_label: "Suède",
    en_label: "Sweden",
    value: "Sweden",
  },
  {
    fr_label: "Suisse",
    en_label: "Switzerland",
    value: "Switzerland",
  },
  {
    fr_label: "Suriname",
    en_label: "Suriname",
    value: "Suriname",
  },
  {
    fr_label: "Eswatini",
    en_label: "Eswatini",
    value: "Eswatini",
  },
  {
    fr_label: "Syrie",
    en_label: "Syria",
    value: "Syria",
  },
  {
    fr_label: "Tadjikistan",
    en_label: "Tajikistan",
    value: "Tajikistan",
  },
  {
    fr_label: "Tanzanie",
    en_label: "Tanzania",
    value: "Tanzania",
  },
  {
    fr_label: "Tchad",
    en_label: "Chad",
    value: "Chad",
  },
  {
    fr_label: "Tchéquie",
    en_label: "Czech Republic",
    value: "Czech Republic",
  },
  {
    fr_label: "Thaïlande",
    en_label: "Thailand",
    value: "Thailand",
  },
  {
    fr_label: "Timor oriental",
    en_label: "East Timor",
    value: "East Timor",
  },
  {
    fr_label: "Togo",
    en_label: "Togo",
    value: "Togo",
  },
  {
    fr_label: "Tonga",
    en_label: "Tonga",
    value: "Tonga",
  },
  {
    fr_label: "Trinité-et-Tobago",
    en_label: "Trinidad and Tobago",
    value: "Trinidad and Tobago",
  },
  {
    fr_label: "Tunisie",
    en_label: "Tunisia",
    value: "Tunisia",
  },
  {
    fr_label: "Turkménistan",
    en_label: "Turkmenistan",
    value: "Turkmenistan",
  },
  {
    fr_label: "Turquie",
    en_label: "Turkey",
    value: "Turkey",
  },
  {
    fr_label: "Tuvalu",
    en_label: "Tuvalu",
    value: "Tuvalu",
  },
  {
    fr_label: "Ukraine",
    en_label: "Ukraine",
    value: "Ukraine",
  },
  {
    fr_label: "Uruguay",
    en_label: "Uruguay",
    value: "Uruguay",
  },
  {
    fr_label: "Vanuatu",
    en_label: "Vanuatu",
    value: "Vanuatu",
  },
  {
    fr_label: "Venezuela",
    en_label: "Venezuela",
    value: "Venezuela",
  },
  {
    fr_label: "Viêt Nam",
    en_label: "Vietnam",
    value: "Vietnam",
  },
  {
    fr_label: "Yémen",
    en_label: "Yemen",
    value: "Yemen",
  },
  {
    fr_label: "Zambie",
    en_label: "Zambia",
    value: "Zambia",
  },
  {
    fr_label: "Zimbabwe",
    en_label: "Zimbabwe",
    value: "Zimbabwe",
  },
];

export const nationalitiesStatistics: Nationality[] = [
  {
    fr_label: "Tout",
    en_label: "All",
    value: "all",
  },
  ...nationalities,
];

export const sexes: Sex[] = [
  {
    fr_label: "Féminin",
    en_label: "Female",
    value: "FEMININE",
  },
  {
    fr_label: "Masculin",
    en_label: "Male",
    value: "MASCULINE",
  },
  {
    fr_label: "Non spécifié​",
    en_label: "Not specified",
    value: "NOT_SPECIFIED",
  },
];

export const occupations: Occupation[] = [
  {
    fr_label: "Animateur",
    en_label: "Animator / Facilitator",
    value: "Animator",
  },
  {
    fr_label: "Chargé de communication et plaidoyer",
    en_label: "Communication and advocacy officer",
    value: "Communication and advocacy officer",
  },
  {
    fr_label: "Chargé de suivi évaluation",
    en_label: "Monitoring and evaluation officer",
    value: "Monitoring and evaluation officer",
  },
  {
    fr_label: "Chercheur",
    en_label: "Researcher",
    value: "Searcher",
  },
  {
    fr_label: "Conseiller en gestion",
    en_label: "Management advisor",
    value: "Management advisor",
  },
  {
    fr_label: "Chef de projet ou programme",
    en_label: "Project or program manager",
    value: "Project or program manager",
  },
  {
    fr_label: "Coordinateur de projet ou programme",
    en_label: "Project or program coordinator",
    value: "Project or program coordinator",
  },
  {
    fr_label: "Directeur de structure",
    en_label: "Director of structure",
    value: "Director of structure",
  },
  {
    fr_label: "Directeur technique",
    en_label: "Technical Director",
    value: "Technical Director",
  },
  {
    fr_label: "Enseignant",
    en_label: "Teacher",
    value: "Teacher",
  },
  {
    fr_label: "Etudiant",
    en_label: "Student",
    value: "Student",
  },
  {
    fr_label: "Technicien agricole",
    en_label: "Agricultural technician",
    value: "Agricultural technician",
  },
  {
    fr_label: "Autres (préciser)",
    en_label: "Others (to specify)",
    value: "Others",
  },
];

export const establishment: Establishment[] = [
  {
    fr_label: "Collectivité territoriale",
    en_label: "Local authority",
    value: "Local authority",
  },
  {
    fr_label: "Entreprise du secteur privé​",
    en_label: "Private sector company",
    value: "Private sector company",
  },
  {
    fr_label: "Etablissement de formation professionnelle",
    en_label: "Vocational school",
    value: "Professional training institution",
  },
  {
    fr_label: "Etablissement d'enseignement supérieur",
    en_label: "Higher education institution",
    value: "Higher education institution",
  },
  {
    fr_label: "Institution de financement​",
    en_label: "Financing institution",
    value: "Financing institution",
  },
  {
    fr_label: "Organisation de producteurs​",
    en_label: "Producer organization",
    value: "Producer organization",
  },
  {
    fr_label: "Organisme de recherche​",
    en_label: "Research organization",
    value: "Research organization",
  },
  {
    fr_label: "OSC et ONG​",
    en_label: "Civil society organizations (CSO) and NGO",
    value: "OSC and ONG",
  },
  {
    fr_label: "Service technique public",
    en_label: "Civil technical service",
    value: "Public technical service",
  },
  {
    fr_label: "Autre​ (préciser)",
    en_label: "Other (to specify)",
    value: "Other",
  },
];
